module.exports = __webpack_public_path__ + "static/media/cellana.f9899aca.avif";